import type { ReactNode } from 'react';

export const symbol_perm_contact_calendar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.5-240Q414-240 354-218.5T240-151v11h480v-5q-50-45-112.5-70t-128-25ZM180-180q58-57 135.5-88.5T480-300q87 0 164 31.5T780-180v-580H180v580Zm203.5-253.5Q344-473 344-530t39.5-96.5Q423-666 480-666t96.5 39.5Q616-587 616-530t-39.5 96.5Q537-394 480-394t-96.5-39.5ZM534-476.24q22-22.23 22-54Q556-562 533.76-584q-22.23-22-54-22Q448-606 426-583.76q-22 22.23-22 54Q404-498 426.24-476q22.23 22 54 22Q512-454 534-476.24ZM180-80q-24 0-42-18t-18-42v-620q0-24 18-42t42-18h65v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q310-861.6 310-848v28h340v-28q0-13.6 9-22.8 9-9.2 23.02-9.2t23.5 9.2Q715-861.6 715-848v28h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H180Zm300-450Zm0 390h240-480 240Z"
		/>
	</svg>
);
